import { faqItems, aboutContent, topicTags, carouselItems, rankingItems } from '@/mocks/homeData';

export function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">常见问答</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">关于51黑料吃瓜网，你想知道的都在这里</p>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <details key={item.id} className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.question}</h3>
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-400 transition-transform duration-200 group-open:rotate-45">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">{aboutContent.title}</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">不放过每一口瓜</p>
        <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
          {aboutContent.description.split('\n\n').map((paragraph, idx) => (
            <p key={idx} className={`text-sm md:text-base text-foreground-700 leading-relaxed ${idx > 0 ? 'mt-4' : ''}`}>
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">话题热榜</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">全网最热黑料话题实时追踪</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag) => (
            <a
              key={tag.id}
              href="#ranking"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                tag.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {tag.hot && <i className="ri-fire-line text-sm"></i>}
              {tag.name}
              <span className={`text-xs ${tag.hot ? 'text-primary-500' : 'text-foreground-400'}`}>{tag.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">焦点专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">本周最受关注的黑料事件深度追踪</p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselItems.map((item) => (
            <article key={item.id} className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden flex flex-col sm:flex-row">
              <div className="sm:w-[220px] md:w-[260px] flex-shrink-0">
                <div className="aspect-[16/10] sm:aspect-auto sm:h-full bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {item.summary}
                  </p>
                </div>
                <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/70 text-xs text-foreground-500">
                  <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                  <span><i className="ri-chat-1-line mr-1"></i>{item.comments}</span>
                  <span className="ml-auto">{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-primary-500"></i>;
    if (trend === 'down') return <i className="ri-arrow-down-line text-accent-600"></i>;
    return <span className="w-5 h-5 flex items-center justify-center text-foreground-400 text-sm font-bold">&minus;</span>;
  };

  const getTagStyle = (tag: string) => {
    if (tag === '爆') return 'bg-primary-500 text-background-50';
    if (tag === '热') return 'bg-accent-500 text-background-50';
    return 'bg-secondary-500 text-background-50';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">热门榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">51黑料今日热度排行榜 Top 5</p>
        <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.id}
              href="#carousel"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 truncate">{item.title}</p>
              </div>
              <span className={`flex-shrink-0 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${getTagStyle(item.tag)} whitespace-nowrap`}>
                {item.tag}
              </span>
              <span className="flex-shrink-0 text-xs text-foreground-500 w-16 text-right whitespace-nowrap">{item.heat}</span>
              <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                {getTrendIcon(item.trend)}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}